import {SpanIcon} from '@mazraeapp/react_icon_kit';
import React from 'react';
interface StepTwoProps {
  choosed: IPromotedAdvertisement[];
  freePlans: IPromotedAdvertisement[];
  setStepChoosed: React.Dispatch<React.SetStateAction<string>>;
}
const StepTwo = ({freePlans, choosed, setStepChoosed}: StepTwoProps) => {
  const reducerFunction = (
    accumulator: number,
    currentValue: IPromotedAdvertisement,
  ) => {
    const foundItem = freePlans.find(item => item.guid === currentValue.guid);

    const priceValue = foundItem
      ? 0
      : currentValue.discounted_price
      ? currentValue.discounted_price
      : currentValue.price;

    return accumulator + priceValue;
  };
  return (
    <div className="flex flex-col w-full px-2 gap-2 py-2">
      <div className="flex flex-col w-full gap-2">
        {choosed.map((item, index) => (
          <div className="flex items-center justify-between" key={index}>
            <span className="text-sm font-Regular">{item.title}</span>
            <div className="items-center flex gap-1">
              <span className="text-sm font-Regular">
                {item.discounted_price
                  ? item.discounted_price.toLocaleString()
                  : item.price.toLocaleString()}
              </span>
              <span className="text-xs font-Regular">تومان</span>
            </div>
          </div>
        ))}
      </div>
      <div className="flex w-full border-dashed border-[1px] h-[1px] border-gray-200" />
      <div className="flex flex-col w-full gap-2">
        <div className="flex items-center justify-between">
          <span className="text-sm font-Regular">جمع سفارش</span>
          <div className="items-center flex gap-1">
            <span className="text-sm font-Regular ">
              {choosed
                .reduce(
                  (accumulator, currentValue) =>
                    accumulator + currentValue.price,
                  0,
                )
                .toLocaleString()}
            </span>
            <span className="text-xs font-Regular">تومان</span>
          </div>
        </div>
        <div className="flex flex-col w-full gap-2">
          {choosed
            .filter(item => item.has_discount)
            .map(item => (
              <div className="flex items-center justify-between">
                <p className="text-sm font-Regular flex items-center">
                  <SpanIcon className="icon-nameDiscount-badge" />
                  <span>
                    تخفیف {item.discount_percent}٪ {item.title}
                  </span>
                </p>
                <div className="items-center flex gap-1">
                  <span className="text-sm font-Regular">
                    {item.discounted_price
                      ? item.discounted_price.toLocaleString()
                      : item.price.toLocaleString()}
                  </span>
                  <span className="text-xs font-Regular">تومان</span>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="flex w-full border-dashed border-[1px] h-[1px] border-gray-200" />
      <p className="flex bg-gray-50 rounded-[8px] py-1  justify-between items-center text-sm font-Medium px-2">
        <span>مبلغ کل:</span>
        <div className="flex items-center gap-1">
          <span>
            {choosed
              .reduce(
                reducerFunction,

                0,
              )
              .toLocaleString()}
          </span>
          <span className="text-xs font-Regular">تومان</span>
        </div>
      </p>
      <div className="flex w-full justify-between gap-2">
        <button
          className="bg-farm-shop-500 h-[48px] w-[60%] px-2 rounded-[8px] flex items-center justify-center text-white text-md font-Medium"
          onClick={() => setStepChoosed('StepThree')}
        >
          ادامه و پرداخت
        </button>
        <button
          className="border border-farm-shop-500 text-farm-shop-500 h-[48px] w-[40%] px-2 rounded-[8px] flex items-center justify-center  text-md font-Medium"
          onClick={() => setStepChoosed('stepOne')}
        >
          انصراف
        </button>
      </div>
    </div>
  );
};

export default StepTwo;
